import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal, showAlert } from '../../../store/reducers/AppSlice'
import React from 'react'
import { useAppDispatch } from '../../../store/hooks/Redux'
import { BpTextArea } from '../../../../shared/components/forms/textarea/BpTextArea'
import { Controller, useForm } from 'react-hook-form'
import { usePostUserSendFeedbackMutation } from '../../../api'
import { useTranslation } from 'react-i18next'

export const FeedbackModal = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [updateInfo] = usePostUserSendFeedbackMutation()

  const {
    control,
    handleSubmit,
    register,
    formState: { errors, isValid },
  } = useForm<any>({
    mode: 'onChange',
    defaultValues: {
      message: '',
    },
  })

  const submit = (values: any) => {
    updateInfo({ sendFeedbackForm: { message: values.message } }).then((response: any) => {
      if (response.data?.success) {
        dispatch(
          showAlert({
            message: t('notifications.success'),
            type: 'success',
            timeout: 2000,
          }),
        )
        dispatch(hideModal())
      }
    })
  }

  return (
    <form className={'flex flex-col'} onSubmit={handleSubmit(submit)}>
      <h3
        className={
          'flex min-h-[55px] w-full items-center border-b-[3px] border-b-[#00326D]/[.02] px-[24px] text-[20px] font-medium'
        }
      >
        {t('components.feedbackModal.giveFeedback')}
      </h3>
      <div className={'flex flex-col gap-[16px] px-[24px] pt-[18px] pb-[16px]'}>
        <Controller
          render={({ field }) => (
            <BpTextArea
              {...field}
              height={'sm'}
              placeholder={t('fields.weLoveFeedback')}
              {...register('message', {
                required: 'Required',
              })}
            />
          )}
          control={control}
          name='message'
        />
      </div>
      <div
        className={
          'flex w-full gap-[12px] border-t-[3px] border-t-[#00326D]/[.02] px-[24px] py-[24px]'
        }
      >
        <BpButton className={'uppercase'} disabled={!isValid} type='submit'>
          {t('buttons.send')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </form>
  )
}
